export const makeDropdownOnChangeEventObject=_ref=>{let{value:value,id:id,name:name}=_ref;return{target:{id:id,name:name,value:value}}};